import { RoleService } from 'app/main/services/roles/role.service';
import { Role } from 'app/main/models/roles/role';
import { TranslationService } from 'app/main/services/translation/translation.service';
import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { fuseAnimations } from 'app/core/animations';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { UserService } from 'app/main/services/users/user.service';
import { SweetAlertService } from 'app/main/services/sweet-alert/sweet-alert.service';
import { CustomValidators } from 'app/main/helpers/custom-validators.helper';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const PASSWORD_REGEX = /^(?=.*[a-zñ])(?=.*[A-ZÑ])(?=.*\d)(?=.*[$@$#%_-])([A-ZÑa-zñ\d$@$#%_-]|[^'\"°|¬!&/()=?¡¿¨*+~{}`^\[\] ]){6,20}$/;

@Component({
    selector: 'fuse-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    animations: fuseAnimations
})
export class FuseChangePasswordComponent implements OnInit, AfterViewInit {

    emailFormControl;
    password;
    confirmPassword;

    userFormGroup;

    newPassword = '';
    confirmNewPassword = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<FuseChangePasswordComponent>,
        private userService: UserService,
        private translationService: TranslationService,
        private roleService: RoleService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder
    ) {
        console.log('FuseChangePasswordComponent > data', data);
        this.initializeFormControlValidators();
    }

    ngOnInit() {
        this.userFormGroup.get('emailFormControl').disable();
    }

    ngAfterViewInit() {

    }

    initializeFormControlValidators() {
        this.userFormGroup = this.fb.group({
            emailFormControl: ['', [Validators.required]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', [Validators.required, Validators.minLength(6)]]
        }, {
                validator: CustomValidators.passwordsMatch // your validation method
            });
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    save() {
        console.log('FuseChangePasswordComponent > save > this.data.user', this.data.user);
        this.userService.setPasswordByUserId(
            this.data.user.Id,
            this.newPassword,
            this.confirmNewPassword).subscribe(response => {
                if (response.ResultCode == 1) {
                    this.dialogRef.close(this.data.user);
                    this.translationService.translate('LABELS.CORRECTLY_MODIFIED_FEMALE', this.translationService.password, (res) => {
                        this.sweetAlertService.success(this.translationService.success, res, null);
                    })
                } else {
                    this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                        this.sweetAlertService.error('Error', res, null);
                    })
                }
            }, error => {
                this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                })
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/users/components/change-password/change-password.component.ts